import { render } from "./ProductGridCardComponent.vue?vue&type=template&id=2a87159f&scoped=true"
import script from "./ProductGridCardComponent.vue?vue&type=script&lang=js"
export * from "./ProductGridCardComponent.vue?vue&type=script&lang=js"

import "./ProductGridCardComponent.vue?vue&type=style&index=0&id=2a87159f&scoped=true&lang=css"

import exportComponent from "/Users/alvinpascasio/pjf-wine-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a87159f"]])

export default __exports__